import React from "react"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import { navigate } from "vike/client/router"

const SuccessDialog = ({ isOpen, onClose }) => {
  const handleSeeOffers = () => {
    navigate("/pricing")
  }

  const texts = TextBundle({ id: "cancellation_success_dialog" });

  return (
    <Modal
      title={texts?.title || "Your subscription has been cancelled!"}
      isOpen={isOpen}
      onClose={onClose}
      variant="aqua_medium"
      //styleOverrides copies the variant values and just adds text-center (it does not work if they are omitted)
      styleOverrides={{ title: "flex-1 text-[24px] md:text-[28px] xl:text-[32px] font-bold text-text text-center leading-tight md:px-10 mt-[100px] mb-0 md:my-0" }}
      className="md:max-w-[580px]"
    >
      <div className="max-w-[360px] md:max-w-full flex flex-col gap-10 md:gap-8 items-center pt-16 md:pt-6 mx-auto md:mx-0">
        <Typography
          variant="info_18"
          className="text-gray_1 text-center md:text-left my-0"
        >
          {texts?.subtitle || "Based on your preferences you may want to check:"}
        </Typography>

        <Button
          variant="primary_s"
          onClick={handleSeeOffers}
          className="w-full"
        >
          {texts?.cta_see_offers || "See Special Offers"}
        </Button>

        <Button
            variant="secondary_s"
            onClick={onClose}
            className="min-w-[100px]"
          >
            {texts?.cta_close || "Close"}
          </Button>
      </div>
    </Modal>
  )
}

export default SuccessDialog
